<template>
	<div style="padding: 0px;">
		<div style="">
			<div style="width: 13%;float: left;border-right: 1px solid lightgrey;max-height: 500px;overflow: auto;">
				<div style="padding: 10px;border-bottom: 1px solid lightgrey;align-items: center;text-align: center;" v-for="(data,idx) in dataList" :key="idx">
					<span>{{data.day}}</span>
					<span style="margin-left: 10px;">{{data.model}}</span>
				</div>
			</div>
			<div style="width: 85%;float: right;max-height: 500px;overflow: auto;">
				<div style="padding: 10px;border-bottom: 1px solid lightgrey;" v-for="(data,idx) in dataorg" :key="idx">
					<span>{{data.time}}</span>
					<span style="margin-left: 10px;">{{data.value}}</span>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">关闭</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { queryRoomAirOpens } from '/static/apiUrl.js'
	import { Decimal } from 'decimal.js'
	export default {
		name : 'AirDetail',
		data() {
			return {
				disabled_cord: false,
				dataList: [],
				dataorg: [],
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			roomid: {
				type: String,
				required: true
			},
			roomname: {
				type: String,
				required: true
			},
			airname: {
				type: String,
				required: true
			},
			day : {
				type : String,
				required : true,
			},
			num : {
				type : String,
				required: true
			},
		},
		watch: {
			roomid : {
				immediate: true,
				handler(newVal) {
					this.initData()
				}
			}
		},
		methods: {
			initData(){
				this.dataList = []
				this.dataorg = []
				queryRoomAirOpens({
					roomid : this.roomid,
					day : this.day,
					num: this.num
				}).then(res => {
					if(0 == res.code){
						this.dataList = res.datas.list
						let keys = Object.keys(res.datas.orage)
						let vs = Object.values(res.datas.orage)
						keys.forEach((key,idx) => {
							this.dataorg.push({
								time: key,
								value: vs[idx]
							})
						})
						//console.log(this.dataorg)
					}
				})
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>